module.exports = __webpack_public_path__ + "static/hero-partners-54e468b38ae2d3f6fb14b297dc797104.svg";